/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState, useEffect} from "react";


import {Col, Row} from "react-bootstrap";


import dateFormat from "dateformat";


import TransportDocumentsSwitcherComponent from "@UIPages/Authenticated/Settings/User/MyFinishedTransports/TransportsList/Transport/Documents/Switcher";
import TransportDocumentsListComponent from "@UIPages/Authenticated/Settings/User/MyFinishedTransports/TransportsList/Transport/Documents/List";


import TRANSPORT_INTERFACE from "@Services/Application/Interfaces/Transports/Transport";


const MONTH_LABELS: any = {
    1: "Stycznia",
    2: "Lutego",
    3: "Marca",
    4: "Kwietnia",
    5: "Maja",
    6: "Czerwca",
    7: "Lipca",
    8: "Sierpnia",
    9: "Września",
    10: "Października",
    11: "Listopada",
    12: "Grudnia"
};


type FinishedTransportProps = {
    TRANSPORT: TRANSPORT_INTERFACE
};

export const FinishedTransportComponent: React.FC<FinishedTransportProps> = ({
    TRANSPORT
}): JSX.Element | null => {


    const [TRANSPORT_SHOW_DOCUMENTS_STATUS, SET_TRANSPORT_SHOW_DOCUMENTS_STATUS] = useState<boolean>(false);


    useEffect(() => {
        return () => {
            SET_TRANSPORT_SHOW_DOCUMENTS_STATUS(false);
        };
    }, []);


    if (!TRANSPORT) return null;


    // const SENT_NUMBERS = TRANSPORT.Comapertments?.map((COMPARTMENT) => {
    //     return !!COMPARTMENT.SENTNumber ? <span key={i}>{COMPARTMENT.ReceiverName}</span> : null;
    // });

    const RECEIVERS = TRANSPORT.Comapertments?.map((COMPARTMENT, i: number) => {
        return !!COMPARTMENT.ReceiverName ? <span key={i}>{COMPARTMENT.ReceiverName}</span> : null;
    });


    return (
    <>

        <Col xs={12} className={"finished-transport-component finished-transport"}>
            <Row className={"finished-transport-content"}>

                <Col xs={9} className={"finished-transport-data"}>
                    <Row className={"finished-transport-data-content"}>

                        {(!!TRANSPORT.CloseDate || !!TRANSPORT.TerminalName) &&
	                    <Col xs={12} className={"finished-transport-header"}>
                            {!!TRANSPORT.CloseDate && <span>{dateFormat(TRANSPORT.CloseDate, "HH:MM")}</span>}
                            {!!TRANSPORT.TerminalName && <span>{TRANSPORT.TerminalName}</span>}
	                    </Col>
                        }

                        {!!TRANSPORT.CloseDate &&
	                    <Col xs={12} className={"finished-transport-information transport-date"}>
		                    <span className={"information-label"}>{dateFormat(TRANSPORT.CloseDate, "d")}</span>
		                    <span className={"information-value"}>{MONTH_LABELS[dateFormat(TRANSPORT.CloseDate, "m")]}</span>
	                    </Col>
                        }

                        {(!!TRANSPORT.FrontTruckRegNo || !!TRANSPORT.RearTruckRegNo) &&
                        <Col xs={12} className={"finished-transport-information transport-vehicles"}>
                            {!!TRANSPORT.FrontTruckRegNo && <span className={"information-label"}>{TRANSPORT.FrontTruckRegNo}</span>}
                            {!!TRANSPORT.FrontTruckRegNo && !!TRANSPORT.RearTruckRegNo && <span className={"information-separator"}>{`/`}</span>}
                            {!!TRANSPORT.RearTruckRegNo && <span className={"information-label"}>{TRANSPORT.RearTruckRegNo}</span>}
                        </Col>
                        }

                        {!!RECEIVERS && RECEIVERS.length > 0 &&
                        <Col xs={12} className={"finished-transport-information transport-receivers"}>
                            <span className={"information-label"}>{`Odbiorcy`}:</span>
                            <span className={"information-value"}>
                                {RECEIVERS}
                            </span>
                        </Col>
                        }

                        {TRANSPORT.TransportNo &&
                        <Col xs={12} className={"finished-transport-information transport-id-number"}>
                            <span className={"information-label"}>{`Nr transportu`}:</span>
                            <span className={"information-value"}>{TRANSPORT.TransportNo}</span>
                        </Col>
                        }

                    </Row>
                </Col>

                <TransportDocumentsSwitcherComponent
                    SHOW_DOCUMENTS_STATUS={TRANSPORT_SHOW_DOCUMENTS_STATUS}
                    SHOW_DOCUMENTS_STATUS_HANDLER={SET_TRANSPORT_SHOW_DOCUMENTS_STATUS}
                />

            </Row>
        </Col>

        {TRANSPORT_SHOW_DOCUMENTS_STATUS &&
	    <TransportDocumentsListComponent TRANSPORT={TRANSPORT} />
        }

    </>
    );


};


export default FinishedTransportComponent;
